import { v4 as uuidv4 } from 'uuid';
import { callAPI,callAPIwithoutJWT, callGetAPI,callGetWithoutJWTAPI } from 'api/ApiUtils';
import {getOPScoreAPIPrefix, getOPSserviceAPIPrefix, getOPSAnonymousServiceAPIPrefix} from 'api/ApiUtils';

 var ProductcartitemResourcePrefix = getOPScoreAPIPrefix()+"/productcartitem";
 var opsCoreWebServicesPrefix = getOPSserviceAPIPrefix();
 var ProductsResourcePrefix = getOPSAnonymousServiceAPIPrefix()+"/products";
 var OpsCorePrefix = getOPScoreAPIPrefix();

 export function getAnonymousCartAPI(payload, successCallBack, failuerCallback){
    //callAPIwithoutJWT(opsCoreWebServicesPrefix+"/anonymous/anonymouscart","POST", payload, successCallBack, failuerCallback); 
    callAPI(opsCoreWebServicesPrefix+"/anonymouscart","POST", payload, successCallBack, failuerCallback); 
 }
 export function deleteCartItemAPI(id, deleteCallBack){
    const token = localStorage.getItem("JWT");
    const requestId = uuidv4().split("-")[4];
    const requestOptions = {
      method: 'DELETE',
      headers: {'X-Request-ID': requestId,'Authorization': `Bearer ${token}`}
    };
    fetch(ProductcartitemResourcePrefix+"/"+id, requestOptions)
        .then((data) => data.json())
        .then((data) => {
            deleteCallBack(data);
        })
  }
  export function updateQuantityAPI(payload, successCallBack, failuerCallback){
    callAPI(opsCoreWebServicesPrefix+"/updatequantity","PUT", payload, successCallBack, failuerCallback); 
}
export function getProductInfoByBusinessidAPI(businessid, setProductList, dataFetchCallBack){
    callGetWithoutJWTAPI(ProductsResourcePrefix+"/businessid/"+businessid+"/businessid", setProductList, dataFetchCallBack, ()=>{});
}
export function getOrderListByCustomerIdAPI(customerId, setOrderList, dataFetchCallBack){

    callGetAPI(OpsCorePrefix+"/ordrs/customerid/"+customerId+"/customerid", setOrderList, dataFetchCallBack, ()=>{});
    
}

export function updateCartAddressAPI(payload, successCallBack, failuerCallback){
    callAPI(opsCoreWebServicesPrefix+"/cartaddress","PUT", payload, successCallBack, failuerCallback); 
}
export function addOrderAPI(payload, successCallBack, failuerCallback){
    callAPI(opsCoreWebServicesPrefix+"/addorder","POST", payload, successCallBack, failuerCallback); 
}
export function updateCartCustomerAPI(payload, successCallBack, failuerCallback){
   callAPI(opsCoreWebServicesPrefix+"/cartcustomer","PUT", payload, successCallBack, failuerCallback); 
}
export function getProductsByCartIdAPI(cartid, successCallBack, failuerCallback){
    callAPI(OpsCorePrefix+"/productcartitems/cartid/"+cartid+"/cartid","GET",{},successCallBack, failuerCallback); 
 }

 export function initiatePaymentAPI(payload, successCallBack, failuerCallback){
    const token = localStorage.getItem("JWT");
    const requestId = uuidv4().split("-")[4];
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json','X-Request-ID': requestId,'Authorization': `Bearer ${token}` },
      body: JSON.stringify(payload)
    };
    fetch(opsCoreWebServicesPrefix+"/initPayment", requestOptions)
        .then(function(response) {
            // Always parse JSON, even for error responses
            return response.json().then(data => ({
                status: response.status,
                ok: response.ok,
                body: data
            }));
        })
        .then(({ status, ok, body }) => {
            let errorMessage = "Something Went Wrong";
            if (status === 208){
                errorMessage = "Record already exist";
                failuerCallback(errorMessage);
            } else if (status === 500) {
                errorMessage = 'Internal Server Error';
                failuerCallback(errorMessage);
            } else if (status === 400) {
                // Read error message from API response
                errorMessage = body.message || "Bad Request";
                failuerCallback(errorMessage);
            } else if (ok) {
                successCallBack(body);
            } else {
                failuerCallback(errorMessage);
            }
        })
        .catch(function(error) { 
            console.log('Request failed', error);
            failuerCallback('Internal Server Error');
        });
}
export function confirmPaymentAPI(payload, successCallBack, failuerCallback){
    const token = localStorage.getItem("JWT");
    const requestId = uuidv4().split("-")[4];
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json','X-Request-ID': requestId,'Authorization': `Bearer ${token}` },
      body: JSON.stringify(payload)
    };
    fetch(opsCoreWebServicesPrefix+"/confirmpayment", requestOptions)
        .then(function(response) {
            // Always parse JSON, even for error responses
            return response.json().then(data => ({
                status: response.status,
                ok: response.ok,
                body: data
            }));
        })
        .then(({ status, ok, body }) => {
            let errorMessage = "Something Went Wrong";
            if (status === 208){
                errorMessage = "Record already exist";
                failuerCallback(errorMessage);
            } else if (status === 500) {
                errorMessage = 'Internal Server Error';
                failuerCallback(errorMessage);
            } else if (status === 400) {
                // Read error message from API response
                errorMessage = body.message || "Bad Request";
                failuerCallback(errorMessage);
            } else if (ok) {
                successCallBack(body);
            } else {
                failuerCallback(errorMessage);
            }
        })
        .catch(function(error) { 
            console.log('Request failed', error);
            failuerCallback('Internal Server Error');
        });
}